import React, { useMemo, useState } from "react";
import "./A1DeviceLimit.css";

const INITIAL_VISIBLE_APPS = 5;

const parsePayload = (value, fallback) => {
  if (!value) return fallback;
  if (typeof value === "object") return value;

  try {
    return JSON.parse(value);
  } catch {
    return fallback;
  }
};

const getDeviceCount = (app) => {
  if (app?.deviceLimit !== undefined && app?.deviceLimit !== null) {
    return app.deviceLimit;
  }

  return "";
};

const A1DeviceLimitList = ({ item }) => {
  const [showAll, setShowAll] = useState(false);
  const payload = useMemo(
    () => parsePayload(item?.text_data ?? item?.text, {}),
    [item?.text_data, item?.text]
  );

  const apps = Array.isArray(payload)
    ? payload
    : Array.isArray(payload?.data)
    ? payload.data
    : [];
  const visibleApps = showAll ? apps : apps.slice(0, INITIAL_VISIBLE_APPS);

  if (apps.length === 0) return null;

  return (
    <div className="a1-device-limit-table-wrap volte-text">
      <table className="a1-device-limit-table">
        <thead>
          <tr>
            <th>App</th>
            <th>No of Devices</th>
          </tr>
        </thead>
        <tbody>
          {visibleApps.map((app, index) => (
            <tr key={`${app?.appName || "app"}-${index}`}>
              <td>
                <div className="a1-device-limit-app">
                  {app?.appLink && (
                    <img
                      className="a1-device-limit-table-logo"
                      src={app.appLink}
                      alt={app.appName || "App"}
                    />
                  )}
                  <span>{app?.appName}</span>
                </div>
              </td>
              <td className="a1-device-limit-count">{getDeviceCount(app)}</td>
            </tr>
          ))}
        </tbody>
      </table>

      {apps.length > INITIAL_VISIBLE_APPS && (
        <button
          type="button"
          className="a1-device-limit-toggle"
          onClick={() => setShowAll((value) => !value)}
        >
          {showAll ? "View Less Apps -" : "View More Apps +"}
        </button>
      )}
    </div>
  );
};

export default A1DeviceLimitList;
